// @flow
import React from "react";
import SvgIconContainer from '../SvgIconContainer';

export default (
	{
		unit = 'em',
		...rest
	}: Object = {}) => (
	<SvgIconContainer viewBox="0 0 16 16" {...rest} unit={unit}>
		<g stroke="none" strokeWidth="1" fillRule="evenodd">
			<path d="M2,11.5064937 L9.35584349,4.15065025 L11.8493498,6.64415651 L4.49350627,
			14 L2,14 L2,11.5064937 Z M13.7818171,4.71168916 L12.535064,5.95844229 L10.0415577,
			3.46493602 L11.2883108,2.21818289 C11.5792214,1.92727237 11.880517,1.92727237
			12.1922069,2.21818289 L13.7818171,3.80779313 C14.0727276,4.11948298 14.0727276,
			4.42077864 13.7818171,4.71168916 Z" />
		</g>
	</SvgIconContainer>
);


// WEBPACK FOOTER //
// ./src/components/Icons/Edit.js